<template>
    <div>
        <!-- Контейнер для редактора Quill -->
        <div ref="editorEl"></div>
    </div>
</template>

<script>
import { ref, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import Quill from 'quill';

export default {
    name: 'QuillEditor',
    props: {
        stepData: {
            type: Object,
            required: true,
        },
    },
    setup(props, { emit }) {
        const editorContent = ref('');
        const toolbarOptions = ref([
            [{ header: [2, 3, false] }],
            ['|'],
            ['bold', 'italic', 'underline', 'strike', { 'background': [] }, 'link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ 'direction': 'rtl' }, { 'align': [] }],
            ['clean'],
        ]);

        const editorEl = ref(null);
        let quill;
        let isQuillUpdating = false;
        let textChangeHandler;

        onMounted(async () => {

            if (!editorEl.value) {
                return;
            }

            quill = new Quill(editorEl.value, {
                theme: 'snow',
                modules: {
                    toolbar: toolbarOptions.value,
                },
                clipboard: {
                    matchers: [
                        
                    ]
                }
            });

            // Ждём завершения рендера
            await nextTick();

            // Принудительно вставляем начальное содержимое
            if (props.stepData.description) {
                setEditorContent(props.stepData.description);
            }

            // Отслеживаем изменения текста в Quill
            textChangeHandler = () => {
                if (isQuillUpdating) return;

                const newContent = quill.root.innerHTML;

                if (newContent !== editorContent.value) {
                    editorContent.value = newContent;
                    emit('update:description', newContent);
                }
            };
            quill.on('text-change', textChangeHandler);
        });

        // Функция для принудительного обновления содержимого Quill
        function setEditorContent(content) {
            quill.clipboard.dangerouslyPasteHTML(content);
            editorContent.value = quill.root.innerHTML;
        }

        // Следим за изменениями в props.stepData.description
        watch(
            () => props.stepData.description,
            (newDescription) => {

                if (!quill || newDescription === editorContent.value) {
                    return;
                }

                // Принудительно обновляем содержимое Quill
                isQuillUpdating = true;
                setEditorContent(newDescription);
                isQuillUpdating = false;
            }
        );

        onBeforeUnmount(() => {
            if (quill && textChangeHandler) {
                quill.off('text-change', textChangeHandler);
            }
            quill = null;
        });

        return {
            editorContent,
            toolbarOptions,
            editorEl,
        };
    },
};
</script>
